import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { buttonClassName } from './buttonClasses';
import type { ButtonClassNameOptions } from './buttonClasses';

export interface ButtonProps
    extends ButtonHTMLAttributes<HTMLButtonElement>,
    ButtonClassNameOptions { }

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    function Button(
        {
            variant = 'primary',
            width = 'auto',
            className,
            type = 'button',
            ...props
        },
        ref
    ) {
        return (
            <button
                ref={ref}
                type={type}
                className={buttonClassName({ variant, width, className })}
                {...props}
            />
        );
    }
);
